import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { MainLayout } from "../global/Layout";
import { CircularProgress, Box } from "@mui/material";
import { QueryBuilderCacheProvider } from "../context/QueryBuilderCacheContext";
import { QueryBuilderDataProvider } from "../context/QueryBuilderDataContext";

const PrivateRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <QueryBuilderCacheProvider>
      <QueryBuilderDataProvider>
        <MainLayout />
      </QueryBuilderDataProvider>
    </QueryBuilderCacheProvider>
  );
};

export default PrivateRoute;